<template>
  <div class="box">
    <h3>Ad Creative</h3>

    <div class="upload-zone">
      <div class="upload-box" @click="triggerFileInput">
        <div class="upload-icon">
          <Upload />
        </div>
        <p>Upload your video</p>
        <small>Supported formats: mp4, mov, mpeg, avi</small>
      </div>

      <input
        type="file"
        ref="videoInput"
        style="display: none"
        accept="video/mp4,video/mov,video/mpeg,video/avi"
        @change="handleFileUpload"
      />

      <div class="uploading" v-if="uploading">
        <label>Uploading - 1/1 video</label>
        <div class="boxxb">
          <div class="d-flex align-center justify-space-between">
            <div class="file-name">
              {{ store.adCreativeData.videoFile?.name }}
            </div>
            <span class="remove-icon" @click="clearUpload">✕</span>
          </div>
          <div class="progress">
            <div class="bar" :style="{ width: progress + '%' }"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="form-group">
      <label class="tit">Headline <span class="required">*</span></label>
      <input
        type="text"
        v-model="store.adCreativeData.headline"
        placeholder="Write post headline"
      />
    </div>

    <div class="form-group">
      <label class="tit">Caption <span class="required">*</span></label>
      <input
        type="text"
        v-model="store.adCreativeData.caption"
        placeholder="Write post caption"
      />
    </div>
  </div>
</template>

<script>
import Upload from "../icons/Upload.vue";
import { useSuperAddStore } from "@/store/superAddStore";

export default {
  name: "AdCreativeBox",
  components: { Upload },
  data() {
    return {
      uploading: false,
      progress: 0,
      store: useSuperAddStore(),
    };
  },
  methods: {
    triggerFileInput() {
      this.$refs.videoInput.click();
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      this.store.adCreativeData.videoFile = file;
      this.uploading = true;
      this.progress = 0;

      const interval = setInterval(() => {
        if (this.progress >= 100) {
          clearInterval(interval);
        } else {
          this.progress += 10;
        }
      }, 300);
    },
    clearUpload() {
      this.store.adCreativeData.videoFile = null;
      this.uploading = false;
      this.progress = 0;
      this.$refs.videoInput.value = "";
    },
    validate() {
      const errors = [];
      if (!this.store.adCreativeData.headline?.trim()) {
        errors.push("Headline is required");
      }
      if (!this.store.adCreativeData.caption?.trim()) {
        errors.push("caption is required");
      }
      if (!this.store.adCreativeData.videoFile) {
        errors.push("Video upload is required");
      }
      return errors;
    },
    getData() {
      return { ...this.store.adCreativeData };
    },
  },
};
</script>

<style scoped>
.box {
  background: white;
  padding: 1.5rem;
  border-radius: 12px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  flex: 1;
  min-width: 400px;
}

h3 {
  margin-bottom: 1.5rem;
  font-size: 18px;
  font-weight: 600;
}

.upload-zone {
  margin-bottom: 1.5rem;
  cursor: pointer;
}

.upload-box {
  background: #f5f5f5;
  padding: 2rem;
  border: 2px dashed #c2c2c2;
  border-radius: 10px;
  text-align: center;
  color: #555;
}

.upload-box a {
  color: #207878;
  text-decoration: underline;
  font-weight: 500;
}

.upload-icon img {
  width: 40px;
  height: 40px;
  margin-bottom: 1rem;
}

.uploading {
  margin-top: 1rem;
  font-size: 14px;
  color: #333;
}

.file-name {
  font-weight: 500;
  margin-bottom: 0.25rem;
}

.progress {
  background: #e0e0e0;
  height: 8px;
  border-radius: 5px;
  overflow: hidden;
}

.progress .bar {
  width: 100%;
  height: 100%;
  background: #22c55e;
}

.form-group {
  margin-bottom: 1.25rem;
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  align-items: center;
}
.tit {
  min-width: 14rem;
}

input[type="text"] {
  padding: 0.65rem;
  border: 1px solid #ccc;
  border-radius: 8px;
  width: 100%;
}

.required {
  color: red;
}
.boxxb {
  border: 1px solid #ccc;
  padding: 0.3rem;
  width: 50%;
  border-radius: 0.2rem;
  margin-top: 0.5rem;
}
.file-name-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.remove-icon {
  cursor: pointer;
  font-size: 16px;
  color: #888;
  transition: color 0.2s;
  padding: 0 8px;
}

.remove-icon:hover {
  color: #f44336; /* أحمر عند الـ hover */
}
</style>
